export interface ForYouItem {
  title: string
  body: string
  icon: 'leaf' | 'home' | 'gift' | 'store'
}

export const forYouItems: ForYouItem[] = [
  {
    icon: 'leaf',
    title: 'You want a calm, creative hobby',
    body: 'Time with your hands busy and away from a screen, with something lovely at the end of it.',
  },
  {
    icon: 'home',
    title: 'You love natural, delicate decor',
    body: 'Botanical pieces that suit your home and stay beautiful for years.',
  },
  {
    icon: 'gift',
    title: 'You want to make one-of-a-kind gifts',
    body: 'Flowers from your own garden turned into a gift no one else can buy.',
  },
  {
    icon: 'store',
    title: 'You would love to sell your pieces',
    body: 'Low-cost materials, handmade pieces people are happy to pay for.',
  },
]
